import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Privacy Policy</h1>

        <p>
          This Privacy Policy applies to the Galaxy Executive App
          (referred to as the "Application") for mobile devices that was created
          by Galaxy Shipping (referred to as the "Service Provider") as a free
          service. This service is intended for use "AS IS".
        </p>

        <section style={styles.section}>
          <h2 style={styles.heading}>Application Purpose</h2>
          <p>
            The Application is designed only to allow authorized users to log in
            and access documents or information made available by the Service
            Provider.
          </p>
          <p>
            User accounts are not created the Application. User accounts
            are created and managed in the ERP system by the Service Provider or
            authorized administrators.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Information Collection and Use</h2>
          <p>
            To use the Application, users must log in with credentials that are
            created and managed through the ERP system.
          </p>
          <p>
            The Application may process limited information necessary for user
            authentication and access, such as:
          </p>
          <ul style={styles.list}>
            <p>User login credentials</p>
            <p>User identifier or account-related information from the ERP system</p>
            <p>Device type</p>
            <p>Operating system</p>
            <p>Basic usage or access logs</p>
          </ul>
          <p>
            This information is used only to authenticate users, provide access
            to the Application, maintain security, and ensure proper
            functioning.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>ERP User Management</h2>
          <p>
            All user account creation, updates, permissions, and access control
            are handled through the ERP system, not through the Application
            itself.
          </p>
          <p>
            If a user needs account creation, modification, or deactivation,
            this must be handled by the Service Provider or the relevant ERP
            administrator.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Document and Information Access</h2>
          <p>
            After login, users may access or download documents and information
            made available to them by the Service Provider, according to their
            authorized access level.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Third Party Access</h2>
          <p>
            The Application does not sell or rent personal data to third
            parties.
          </p>
          <p>
            Information may be processed through systems or service providers
            used by the Service Provider strictly for authentication, security,
            hosting, or operational purposes.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Data Retention Policy</h2>
          <p>
            User account information is retained and managed according to the
            policies of the ERP system and the Service Provider's internal
            requirements.
          </p>
          <p>
            Basic system and access logs may be retained for security,
            operational, and audit purposes for a reasonable period of time.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Children</h2>
          <p>
            The Application is not intended for children under the age of 13,
            and the Service Provider does not knowingly collect personal
            information from children.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Security</h2>
          <p>
            The Service Provider takes reasonable administrative, technical, and
            organizational measures to protect user information and secure
            access to the Application.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Changes</h2>
          <p>
            This Privacy Policy may be updated from time to time. Any changes
            will be reflected on this page.
          </p>
        </section>

        <p>
          <strong>This privacy policy is effective as of 2026-04-13</strong>
        </p>

        <section style={styles.section}>
          <h2 style={styles.heading}>Your Consent</h2>
          <p>
            By using the Application, you agree to this Privacy Policy.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Contact Us</h2>
          <p>
            If you have any questions regarding this Privacy Policy, please
            contact the Service Provider at{" "}
            <a href="mailto:info@galaxyshipping.com" style={styles.link}>
              info@galaxyshipping.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f8fa",
    minHeight: "100vh",
    padding: "40px 20px",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    padding: "32px",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    lineHeight: "1.7",
    color: "#222",
  },
  title: {
    fontSize: "32px",
    marginBottom: "24px",
  },
  section: {
    marginTop: "24px",
  },
  heading: {
    fontSize: "22px",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
  },
  link: {
    color: "#0d6efd",
    textDecoration: "none",
  },
};

export default PrivacyPolicyPage;